// Phase 6A — shared label + colour maps for the Calendar page.
// Data-only; keeps Calendar components focused on rendering.

export const APPOINTMENT_TYPE_LABELS = {
  phone_callback: 'Phone callback',
  showroom_visit: 'Showroom visit',
  test_drive: 'Test drive',
  finance_call: 'Finance call',
  trade_appraisal: 'Trade appraisal',
  manager_call: 'Manager call',
};

export const STATUS_COLORS = {
  scheduled: 'bg-sky-100 text-sky-800',
  confirmed: 'bg-emerald-100 text-emerald-800',
  completed: 'bg-gray-200 text-gray-700',
  cancelled: 'bg-slate-200 text-slate-600',
  no_show: 'bg-amber-100 text-amber-800',
  needs_review: 'bg-rose-100 text-rose-800',
};

export const SOURCE_LABELS = {
  manual: 'Manual',
  ai_suggested: 'AI suggested',
  ai_created: 'AI created',
  call_transfer_fallback: 'Call transfer',
};

export const CONFIDENCE_COLORS = {
  high: 'bg-emerald-100 text-emerald-800',
  medium: 'bg-amber-100 text-amber-800',
  low: 'bg-rose-100 text-rose-800',
};

// Per-dealer-type terminology bias — broker dealers say "callback"
// in headers/buttons; retail dealers say "appointment".
export const DEALER_TYPE_TERMINOLOGY = {
  broker_remote: { noun: 'callback', cta: 'Book callback' },
  local_retail: { noun: 'appointment', cta: 'Book appointment' },
};

// Phase 6C — calendar sync + reminder status pills for the list/detail views.
export const CALENDAR_SYNC_LABELS = {
  not_synced: 'Not synced',
  synced: 'Synced',
  failed: 'Sync failed',
  skipped: 'Sync skipped',
};

export const CALENDAR_SYNC_COLORS = {
  not_synced: 'bg-slate-100 text-slate-700',
  synced: 'bg-emerald-100 text-emerald-800',
  failed: 'bg-rose-100 text-rose-800',
  skipped: 'bg-gray-100 text-gray-700',
};

export const REMINDER_STATUS_LABELS = {
  not_scheduled: 'Not scheduled',
  scheduled: 'Scheduled',
  sent: 'Sent',
  failed: 'Failed',
  skipped: 'Skipped',
};

export const REMINDER_STATUS_COLORS = {
  not_scheduled: 'bg-slate-100 text-slate-700',
  scheduled: 'bg-sky-100 text-sky-800',
  sent: 'bg-emerald-100 text-emerald-800',
  failed: 'bg-rose-100 text-rose-800',
  skipped: 'bg-gray-100 text-gray-700',
};
